import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { useNavigate, useLocation } from "react-router-dom";
import DataGrid from "./DataGrid";
import ApiAgency from "../../../core/api/api.agency";
import ApiAccount from "../../../core/api/api.account";
import ApiTransaction from "../../../core/api/api.transaction";
import { tools } from "../../../core/utils/tools";
import { EditModal } from "./EditModal";
import { ViewModal } from "./ViewModal";
import { NumericFormat } from "react-number-format";
import GlobalFormControl from "../_Components/GlobalFormControl";
import SelectComponent from "../_Components/ReactSelectComponent";
const EditTransaction = () => {
  let location = useLocation();
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [lAgency, setLAgency] = useState([]);
  const [lAccount, setLAccount] = useState([]);
  const watchAgencyId = watch("agencyId", undefined);
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [fromCreatedDate, setfromCreatedDate] = useState();
  const [toCreatedDate, settoCreatedDate] = useState();
  const [fromCompletionDate, setfromCompletionDate] = useState();
  const [toCompletionDate, settoCompletionDate] = useState();
  const [showModalTransaction, setShowModalTransaction] = useState(false);
  const [showModalEditTransaction, setShowModalEditTransaction] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1)
          ? _.toNumber(pageNumberFromUrl1)
          : getValues("pageNumber");
        // تراکنش های اخر
        const apiData = await ApiTransaction.getAllTransaction({
          agencyId: searchParams.get("agencyId"),
          accountId: searchParams.get("accountId"),
          fromCreatedDate: searchParams.get("fromCreatedDate"),
          toCreatedDate: searchParams.get("toCreatedDate"),
          fromCompletionDate: searchParams.get("fromCompletionDate"),
          toCompletionDate: searchParams.get("toCompletionDate"),
          basketId: searchParams.get("basketId"),
          basketItemPersonId: searchParams.get("basketItemPersonId"),
          name: searchParams.get("name"),
          lastName: searchParams.get("lastName"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });
        setListData(apiData);
        setValue("totalCount", apiData.totalCount);

        // دریافت لیست آژانس ها
        const data1 = await ApiAgency.getAllAgency({ PageNumber: 1, PageSize: 100 });
        setLAgency(data1.data);
        const formInputs = [
          { name: "agencyId", type: "text" },
          { name: "accountId", type: "text" },
          { name: "fromCreatedDate", type: "datePicker" },
          { name: "toCreatedDate", type: "datePicker" },
          { name: "fromCompletionDate", type: "datePicker" },
          { name: "toCompletionDate", type: "datePicker" },
          { name: "basketId", type: "text" },
          { name: "basketItemPersonId", type: "text" },
          { name: "name", type: "text" },
          { name: "lastName", type: "text" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  useEffect(() => {
    (async () => {
      // دریافت لیست حساب ها
      if (watchAgencyId != undefined) {
        let response = await ApiAccount.getAccountByAgencyId(watchAgencyId.value);
        setLAccount(response.data);
      }
    })();
    return () => { };
  }, [watchAgencyId]);

  const onSubmit = async (data) => {
    if (!_.isEmpty(data.basketId) && !validateNumberBasketId(data.basketId)) return;
    if (!_.isEmpty(data.basketItemPersonId) && !validateNumberBasketItemPersonId(data.basketItemPersonId)) return;
    if (data.accountId) data.accountId = data.accountId.value
    if (data.agencyId) data.agencyId = data.agencyId.value
    data.pageNumber = getValues("pageNumber");
    if (data.fromCreatedDate !== null && typeof data.fromCreatedDate === "object") {
      data.fromCreatedDate = tools.DateFormat(data.fromCreatedDate);
    }
    if (data.toCreatedDate !== null && typeof data.toCreatedDate === "object") {
      data.toCreatedDate = tools.DateFormat(data.toCreatedDate);
    }
    if (data.fromCompletionDate !== null && typeof data.fromCompletionDate === "object") {
      data.fromCompletionDate = tools.DateFormat(data.fromCompletionDate);
    }
    if (data.toCompletionDate !== null && typeof data.toCompletionDate === "object") {
      data.toCompletionDate = tools.DateFormat(data.toCompletionDate);
    }
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiTransaction.getAllTransaction(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/editTransaction?${queryString}`);
  };
  const validateNumberBasketId = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketId", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketId");
      return true;
    }
  };
  const validateNumberBasketItemPersonId = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonId", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonId");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">لیست تراکنش ها</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست تراکنش های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            {/* <Link className="btn btn-success" variant="success"
                            key={0}
                            to={{
                                pathname: `/agencyTransaction/0`,
                                state: { id: 0 }
                            }}
                        >
                            <AddCircle className='mr-1' />
                            افزودن تراکنش
                        </Link> */}
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0 ">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="agencyId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={lAgency?.map(item => ({
                                    value: item.id,
                                    label: item.name
                                  }))}
                                  placeholder="انتخاب آژانس"
                                  className="w-100 mt-5"
                                  variant="outlined"
                                  size="small"
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="accountId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={lAccount?.map(item => ({
                                    value: item.id,
                                    label: "نام : " + item.accountOwnerName + " - شماره کارت : " + item.accountNumber
                                  }))}
                                  placeholder="انتخاب حساب"
                                  className="w-100 mt-5"
                                  variant="outlined"
                                  size="small"
                                  field={field}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  placeholder=" از تاریخ ایجاد"
                                  onChange={(date) => {
                                    var toCreatedDate = getValues("toCreatedDate");
                                    onChange(date);
                                    if (
                                      !toCreatedDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCreatedDate).getTime())
                                    ) {
                                      // Set the value of toCreatedDate to the same as toCreatedDate
                                      setValue("toCreatedDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تا تاریخ ایجاد"
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromCompletionDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  placeholder=" از تاریخ موثر"
                                  onChange={(date) => {
                                    var toCompletionDate = getValues("toCompletionDate");
                                    onChange(date);
                                    if (
                                      !toCompletionDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCompletionDate).getTime())
                                    ) {
                                      // Set the value of toCompletionDate to the same as toCompletionDate
                                      setValue("toCompletionDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toCompletionDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تا تاریخ موثر"
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="basketId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره سفارش"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  type="search"
                                  error={!!errors.basketId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketId(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketId && (
                              <div className="text-small-1 text-danger"> {errors.basketId.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="basketItemPersonId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره بلیط"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  type="search"
                                  variant="outlined"
                                  error={!!errors.basketItemPersonId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonId(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonId && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonId.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="name"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام مسافر"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی مسافر"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive px-2 mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  setShowModalTransaction={setShowModalTransaction}
                  setShowModalEditTransaction={setShowModalEditTransaction}
                  setSelectedTransaction={setSelectedTransaction}
                />
              </Col>
              {showModalTransaction && (
                <ViewModal
                  showModalTransaction={showModalTransaction}
                  setShowModalTransaction={setShowModalTransaction}
                  selectedTransaction={selectedTransaction}
                />
              )}
              {showModalEditTransaction && (
                <EditModal
                  showModalEditTransaction={showModalEditTransaction}
                  setShowModalEditTransaction={setShowModalEditTransaction}
                  selectedTransaction={selectedTransaction}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default EditTransaction;
